import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

const MeetingList = (props) => {
  document.title = "Manage Schedules - VUF";

  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Manage Schedules", link: "#" },
  ];
  const [isLoading, setLoading] = useState(false);
  const [meetingList, setMeetingList] = useState([]);
  const state = {
    isLoading: false,
    errors: {},
    ResErrors: {},
    isRedirect: false,
    country_code: "+91",
    ccode: "+91",
    email: "",
    mobileNo: "",
    remark: "",
    assignRole: "",
    firstName: "",
    lastName: "",
    country: "",
    state: "",
    city: "",
    scheduleAttendantLinkToCopy: url.CurrentUrl + "attendance/",
    QRCodeValue: "ABCD12345",
    locations: [],
    counts: {
      totalUsers: 0,
      mainApp: 0,
      gbnApp: 0,
      sangathanApp: 0,
      eventUsers: 0,
      locationUsers: 0,
    },
    selectionRange: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },

    showDatePicker: false,
  };

  useEffect(() => {
    getMeetingList();
    props.setBreadcrumbItems("Manage Schedules", breadcrumbItems);
  }, []);
  function getMeetingList(filter = false) {
    // getReportDashboard
    setLoading(true);
    let urlPath = "schedule/list/";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        // console.log(responseData.response)
        setMeetingList(responseData.response);
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
        // this.setState({ loading: false });
      })
      .finally((final) => {});
  }
  function handleDeleteClick(e, schedule) {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this schedule?"
    );
    if (confirmDelete) {
      //state.deleteItemId = schedule._id;
      onCheckDelete(e, schedule._id);

      console.log("Item deleted.");
    } else {
      console.log("Deletion canceled.");
    }
  }
  function onCheckDelete(e, scheduleId) {
    e.preventDefault();

    setLoading(true);

    let urlPath = "schedule/delete/" + scheduleId;

    fetch(url.VUF_APP_API + urlPath, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          toast.success("Schedule Removed Successfully.");
          getMeetingList();
        } else if (!responseData.status && responseData.error) {
          toast.error(responseData?.error || "Error");
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }
  const formatDate = (date, time) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const formattedMeetingList = meetingList.map((schedule) => ({
    ...schedule,
    attendance: schedule.attendanceCount ? schedule.attendanceCount : "0",
    start_date_time: formatDate(schedule.start_date),
    end_date_time: formatDate(schedule.end_date),
    schedule_status: schedule.schedule_status,
    schedule_type: schedule.schedule_type,
    RegLink: [
      <a
        data-toggle="tooltip"
        title="Copy Registration Link"
        className="btn btn-outline-warning btn-sm copylink "
        onClick={() => {
          navigator.clipboard.writeText(
            state.RegistrationLinkToCopy + `${schedule._id}`
          );
        }}
      >
        <span className=" menu-icon fas fa fa-clone"></span>
      </a>,
    ],
    EventLink: [
      <a
        data-toggle="tooltip"
        title="Copy Event Attendant Link"
        className="btn btn-outline-warning btn-sm copylink"
        onClick={() => {
          navigator.clipboard.writeText(
            state.scheduleAttendantLinkToCopy + `${schedule._id}`
          );
        }}
      >
        <span className=" menu-icon fas fa fa-clone"></span>{" "}
      </a>,
    ],
    Action: [
      <Link
        to={`/ScheduleDetails/${schedule._id}`}
        className="btn btn-outline-info btn-sm m-1 "
      >
        <span className="menu-text">
          <span className=" menu-icon fas fa fa-eye"></span>
        </span>
      </Link>,
      <Link
        to={`/EditSchedule/${schedule._id}`}
        className="btn btn-outline-warning btn-sm m-1 "
      >
        <span className="menu-text">
          <span className=" menu-icon fas fa fa-pen"></span>
        </span>
      </Link>,
      <button
        type="button"
        className="btn btn-outline-danger btn-sm  m-1"
        onClick={(e) => {
          handleDeleteClick(e, schedule);
        }}
      >
        <span className=" menu-icon fas fa fa-trash"></span>
      </button>,
    ],
  }));
  const tableData = {
    columns: [
      {
        label: "Title",
        field: "title",
        sort: "asc",
        width: 23,
      },
      {
        label: "Description",
        width: 13,
        sort: "asc",
        field: "description", //[moment(registrationStartDate).format("DD MMM YYYY"), <br />, " to ", <br />, moment(registrationEndDate).format("DD MMM YYYY")]
      },
      {
        label: "Start Date/time",
        width: 13,
        sort: "asc",
        field: "start_date_time",
      },
      {
        label: "End Date/time",
        width: 13,
        sort: "asc",
        field: "end_date_time",
      },
      {
        label: "Attendance",
        width: 13,
        sort: "asc",
        field: "attendance",
      },
      {
        label: "Attnd. Link",
        width: 10,
        sort: "asc",
        field: "EventLink",
      },
      {
        label: "Status",
        width: 10,
        sort: "asc",
        field: "schedule_status",
      },
      {
        label: "Type",
        width: 10,
        sort: "asc",
        field: "schedule_type",
      },
      {
        label: "Action",
        width: 18,
        sort: "asc",
        field: "Action",
      },
    ],
    rows: formattedMeetingList,
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="row align-items-center">
                  <div className="col d-flex justify-content-between align-items-center">
                    <CardTitle className="h4 mb-0">Manage Schedules</CardTitle>
                    <Link
                      to="/NewSchedule"
                      className="btn btn-outline-primary h5 mb-0"
                    >
                      <span className="menu-text">
                        <i className="fa fa-plus me-2"></i>
                        Schedule
                      </span>
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <br />
                <div className="row">
                  <MDBDataTable responsive striped bordered data={tableData} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(MeetingList);
